import React, { useState, useEffect } from 'react';
import { getFormattedPriceObject } from '@/helpers/currencyHelpers';
import { haversine } from '@/helpers/locationHelpers';
import { useCurrencyConverter } from '@/hooks/currencyConverter.hook';
import { useFetchAllSpacesSubtypeRelationships } from '@/services/spacesSubtypeRelationshipService';
import { MMAXIMUM_DISTANCE_SEARCH_SPACES } from '@/types/distance.constants';

export const useProductPreList = (searchFormData, currencyData, isFromMexico) => {
  const [isLoading, setIsLoading] = useState(true);
  const [spacesDataFromBackend, setSpacesDataFromBackend] = useState([]);

  const { data, error } = useFetchAllSpacesSubtypeRelationships();

  const coordinates = searchFormData?.coordinates;

  const formatSpacesData = (spacesData) => {
    const filteredSpacesByDistance = spacesData
      ?.map((space) => {
        const distance = haversine(
          coordinates.lat,
          coordinates.lng,
          parseFloat(space?.space_latitude),
          parseFloat(space?.space_logitude),
        );
        return { ...space, distance };
      })
      ?.filter((space) => space?.distance <= MMAXIMUM_DISTANCE_SEARCH_SPACES)
      ?.filter(
        (space) => space?.subtype_title.toLowerCase() === searchFormData?.spaceType.toLowerCase(),
      )
      .sort((a, b) => a.distance - b.distance);

    let orderedSpacesDataByCountry = isFromMexico
      ? filteredSpacesByDistance.sort((a, b) => {
          if (a.space_id === 151 && b.space_id !== 151) return -1;
          if (a.space_id !== 151 && b.space_id === 151) return 1;
          return 0;
        })
      : filteredSpacesByDistance.sort((a, b) => {
          if (a.space_id === 154 && b.space_id !== 154) return -1;
          if (a.space_id !== 154 && b.space_id === 154) return 1;
          return 0;
        });

    const normalItems = orderedSpacesDataByCountry.filter(
      (item) => !item.relationship_title?.includes('Network'),
    );

    const networkItems = orderedSpacesDataByCountry.filter((item) =>
      item.relationship_title?.includes('Network'),
    );

    orderedSpacesDataByCountry = [...normalItems, ...networkItems];

    const enrichedSpacesData = orderedSpacesDataByCountry.map((space) => {
      const formattedPriceObject = getFormattedPriceObject(
        space,
        currencyData?.currency,
      );
      return {
        ...space,
        calculatedPrice: formattedPriceObject?.calculatedPrice,
        currency: formattedPriceObject?.currency,
        formattedPrice: formattedPriceObject?.formattedPrice,
      };
    });

    return enrichedSpacesData;
  };

  useEffect(() => {
    if (data) {
      setSpacesDataFromBackend(formatSpacesData(data));
      setIsLoading(false);
    } else if (error) {
      console.error('Error fetching spaces data:', error);
      setIsLoading(false);
    }
  }, [data, searchFormData, currencyData, error]);

  return {
    isLoading,
    setIsLoading,
    spacesDataFromBackend,
    searchFormData,
  };
};
